/**
 * Custom select
 *
 * Пример использования:
 * <cat-select  cat-field="{{field}}"></cat-select>
 *
 * {{watcher}}
 * options - массив опций, формат:
 *
 * let options = [
 *   {
 *     title: 'По дням',
 *     value: 'day',
 *
 *   },
 *   {
 *     title: 'По неделям',
 *     value: 'week'
 *     isActive: false
 *   }
 * ];
 *
 * [sizeMod] - устанавливает размер селекта, возможные значения (small,big)
 * [isDisabled] - дизейбл селекта
 *
 * {{signal}}
 * Сигнал, вызываемый при выборе option из списка, в аргументах передается field и selectedValue
 *
 * {{field}}
 * Опциональный атрибут, чтобы разруливать какой именно select запросил данные
 */
const css = require('./select.css');
const $ = require('jquery');
const _ = require('lodash');

const SELECT = `.${css.select}`;
const OPTION = `.${css.option}`;
const INPUT = `.${css.input}`;
const DROPDOWN = `.${css.dropdown}`;
const OPTIONS = `.${css.options}`;
const SCROLLBAR = `.${css.scrollbar}`;
const SCROLLTRACK = `.${css.scrolltrack}`;
const IS_HIGHLIGHTED = `.${css.isHighlighted}`;
const IS_UP = `.${css.isUp}`;
const IS_DISABLED = `.${css.isDisabled}`;

class Select {
    constructor () {
        this.template = require('./select.hbs');
    }

    render () {
        const skinName = _.get(this.$context.attributes, 'cat-skin');
        const skin = _.get(css, skinName);

        return this.$context.getWatcherData()
            .then((data) => Object.assign({}, data, { skin }))
            .then((data) => Object.assign({ css }, data));
    }

    bind () {
        this.fillUI();
        return {
            click: {
                [SELECT]: this.clickOnSelect,
                [OPTION]: this.clickOnItem
            },
            mouseenter: {
                [OPTION]: this.enterItem
            },
            keydown: {
                [INPUT]: this.prevent
            },
            keyup: {
                [INPUT]: this.keyHandler
            }
        };
    }

    /**
     * Заполняем дефолтные UI элементы для select
     */
    fillUI () {
        const $el = $(this.$context.element);
        const wrapper = _.get(this.$context.attributes, 'cat-wrapper');
        this.$select = $el.find(INPUT);
        this.$dropdown = $el.find(DROPDOWN);
        this.$itemWrapper = $el.find(OPTIONS);
        this.$items = $el.find(OPTION);

        const activeItem = this.$items.filter(IS_HIGHLIGHTED.substring(1));
        this._selected = activeItem.length ? activeItem.index() : 0;

        if (wrapper) {
            this.$wrapper = $(wrapper);
        }
    }

    /**
     * Инициализация baron
     */
    initBaron () {
        const baron = require('baron');
        const elementId = this.$context.attributes.id;

        baron({
            root: `#${elementId} ${DROPDOWN}`,
            scroller: OPTIONS,
            bar: SCROLLBAR,
            track: SCROLLTRACK,
            $
        });
    }

    /**
     * Prevent нажатия вверх и вниз
     * @param  {Event} e
     */
    prevent (e) {
        if (_.includes([38, 40], e.keyCode)) {
            e.preventDefault();
        }
    }

    /**
     * Переключаем выпадашку по клику на компонент
     * @param {Event} e
     */
    clickOnSelect (e) {
        e.preventDefault();
        e.stopPropagation();

        const $el = $(SELECT);
        const name = $(this.$context.element).attr('cat-name');
        const signalOnToggle = this.$context.props.signalOnToggle;

        if ($el.hasClass(IS_DISABLED.substring(1))) {
            return;
        }

        this.$context.signal(signalOnToggle, { name });

        _.defer(() => {
            this.calculateDropdownHeight();
        });
    }

    /**
     * Клик по option
     * @param  {Event} e
     */
    clickOnItem (e) {
        this.selectValue(e);
    }

    /**
     * Обработчик для клавиатуры
     * @param  {Event} e
     */
    keyHandler (e) {
        const signalOnToggle = this.$context.props.signalOnToggle;
        const name = $(this.$context.element).attr('cat-name');

        switch (e.keyCode) {
            case 13:
                this.$context.signal(signalOnToggle, { name });
                this.selectValue(e);
                break;
            case 27:
                break;
            case 38:
                e.stopPropagation();
                if (this._current > 0) {
                    this._current--;
                }
                break;
            case 40:
                e.stopPropagation();
                if (this._current + 1 < this.$items.length) {
                    this._current++;
                }
                break;
            default:
                break;
        }

        if (_.includes([38, 40], e.keyCode)) {
            this.changeHighlight(this._current);
        }
    }

    /**
     * Когда наводим мышкой на элемент списка меняем подсветку
     * @param  {Event} e
     */
    enterItem (e) {
        const index = $(e.target).index();
        this.changeHighlight(index);
    }

    /**
     * Отправляем сигнал на выбор значения
     */
    selectValue (e) {
        const $currentItem = this.$items.filter(IS_HIGHLIGHTED)[0];
        const selectedValue = $currentItem.getAttribute('cat-value');
        const signalOnSelect = this.$context.props.signalOnSelect;
        const field = _.get(this.$context.attributes, 'cat-field');
        const ctx = this.$context;

        if (signalOnSelect && $currentItem) {
            ctx.signal(signalOnSelect, { selectedValue, field, ctx });
        }
    }

    /**
     * Подсвечиваем текущий элемент
     * @param  {Number} index
     */
    changeHighlight (index) {
        this.$items.removeClass(IS_HIGHLIGHTED.substring(1));
        this.$items.eq(index).addClass(IS_HIGHLIGHTED.substring(1));
        this._current = index;
    }

    /**
     * Вычисляем высоту dropdown
     */
    calculateDropdownHeight () {
        const selectHeight = $(this.$select).outerHeight();
        const offsetTop = $(this.$select).offset().top;
        const scrollTop = $(window).scrollTop();
        const viewportHeight = $(window).height();
        const viewportTop = offsetTop - scrollTop;
        const viewportBottom = viewportHeight - (offsetTop + selectHeight - scrollTop);
        const itemsHeight = this.$items.eq(0).outerHeight() * this.$items.length;

        // если выосота option'ов помещается в нижнюю часть вью порта рисуем вниз
        const height = (itemsHeight < viewportBottom - 30) ? viewportBottom : _.max([viewportTop, viewportBottom]);
        this.$itemWrapper.css('maxHeight', height - 20);
        this.$dropdown.toggleClass(IS_UP.substring(1), height === viewportTop);
    }
}

module.exports = {
    constructor: Select
};



// WEBPACK FOOTER //
// ./packages/button-like-select/index.js